<template>
  <v-container class="how-it-works">
    <h2>How it works for investors and counter-parties</h2>
    <v-row>
      <v-col cols="12" lg="7" md="6">
        <div class="item">
          <span class="num">1</span>
          <div>
            <p class="mb-0">Register to get instant access to all the deals available on the platform</p>
            <p class="explainer">No NDA needed.</p>
          </div>
        </div>
        <div class="item">
          <span class="num">2</span>
          <p>Browse deals and select specific deals of interest.</p>
        </div>
        <div class="item">
          <span class="num">3</span>
          <p>Sign NDA for each deal selected.</p>
        </div>
        <div class="item">
          <span class="num">4</span>
          <p>Gain access to detailed deal information and documents.</p>
        </div>
      </v-col>
      <v-col cols="12" lg="5" md="6" align-self="end">
        <div class="contact">
          <p class="text">The U.S. Government has partnered with CrossBoundary to deliver the Prosper Africa Virtual Deal Room to U.S. businesses and investors.</p>
          <p class="text mb-1">For questions, please contact </p>
          <a href="mailto:dealroom@crossboundary.com" @click="contactUs">dealroom@crossboundary.com</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'how-it-works',
  methods: {
    contactUs () {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-contact-us',
        eventLabel: 'Contact us email click'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.how-it-works {
  padding-top: 100px;
  padding-bottom: 80px;
}
h2 {
  color: $gray-primary;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  font-family: $header-font;
  margin-bottom: 20px;
}
.item {
  display: flex;
  .num {
    display: inline-block;
    background: #002f6c;
    border-radius: 50%;
    color: #fff;
    width: 25px;
    min-width: 25px;
    height: 25px;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
    margin-right: 20px;
  }
}
.contact {
  background: rgba(255,251,243);
  padding: 40px;
  color: #002f6c;
  a {
    color: #002f6c;
    font-size: 16px;
    font-weight: 500;
    font-family: $header-font;
    text-decoration: none;
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
  .text {
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    color: #002f6c;
  }
}
.explainer {
  color: #626262;
  opacity: 0.8;
}
</style>
